import { Outlet } from "react-router-dom";
import { Header } from "./Header";
import { Footer } from "./Footer";
import { BetaBanner } from "./BetaBanner";
import { useReferralCapture } from "../../features/referral";

/**
 * Main Layout Component
 *
 * Root layout wrapper with sticky header, responsive main content area,
 * and footer. Provides proper padding for mobile and desktop viewports.
 */
export function MainLayout() {
  // Capture referral codes from URL (?ref=CODE) on first load
  useReferralCapture();

  return (
    <div className="min-h-screen bg-bg-light flex flex-col">
      <BetaBanner />
      <Header />
      <main className="flex-grow w-full">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
